import { Box, Container } from '@mui/material';
import { useTheme, useMediaQuery } from "@mui/material";

import AuthBackground from '../../common/Icons/auth_wrapper_bg.png';
import { useNavigate } from 'react-router-dom';
import routes from 'config/routes';

const AuthWrapper = ({ children, isPopup = true }) => {
    const navigate = useNavigate()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '24px',
                    zIndex: 10,
                    background: '#FFF',
                    height: '82px',
                     boxShadow: isMobile ? "0px 4px 10px rgba(0, 0, 0, 0.1)" :''
                }}
            >
                <div
                    style={{
                        color: '#184353',
                        textAlign: 'center',
                        fontFamily: 'Abril Fatface',
                        fontSize: '24px',
                        fontWeight: 400,
                        cursor:'pointer'
                    }}
                    onClick={()=>navigate(routes.start)}
                >
                    Be:Seen
                </div>
            </Box>
            {!isMobile && isPopup ? (
                <Box
                    sx={{
                        minHeight: 'calc(100vh - 82px)',
                        backgroundImage: `url(${AuthBackground})`,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',

                        backgroundPosition: 'center',
                        objectFit: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundAttachment: 'fixed',
                        backgroundSize: '100% 100%',
                    }}
                >
                    <Container
                        disableGutters
                        sx={{
                            backgroundColor: '#FFF',
                            borderRadius: '12px',
                            boxShadow: `0px 15px 35px 0px rgba(62, 62, 74, 0.12)`,
                            padding: '40px',
                            width: '400px',
                        }}
                    >
                        {children}
                    </Container>
                </Box>
            ) : (
                <Box
                    sx={{
                        minHeight: "calc(100vh - 82px)",
                        overflow: "auto",
                        width: "100%",
                        padding: "20px",
                        backgroundColor:'rgba(245, 241, 237, 0.5)',
                        // alignContent:'center'
                        "@media (min-width: 1024px)": {
                            padding: "50px 200px",
                        },
                    }}
                >


                    {children}
                </Box>
            )}
        </Box>
    );
};
export default AuthWrapper;
